import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { COLORES } from '../../../../config/colores'
import { makeStyles } from '@material-ui/core'
import { monitorDeEmbarque, totalCupos, totalesCircuito, totalStock, totalMercaderia } from '../../actions/dashboardActions'
import EstadoElevador from '../../components/dashboard/EstadoElevador'

const useStyles = makeStyles(() => ({
  container: {
    backgroundColor: COLORES.black,
    borderRadius: '22px',
    minHeight: '88vh',
    marginTop: '-3.5%',
    padding: '18px',
    color: 'white'
  }
}))

function Dashboard (props) {
  const { monitorDeEmbarque, totalCupos, totalesCircuito, totalStock, totalMercaderia } = props
  const classes = useStyles()

  useEffect(() => {
    monitorDeEmbarque()
    totalCupos()
    totalesCircuito()
    totalStock()
    totalMercaderia()
  }, [monitorDeEmbarque, totalCupos, totalesCircuito, totalStock, totalMercaderia])

  return (
    <div className={classes.container}>
      <EstadoElevador />
    </div>
  )
}

const mapActionsToProps = {
  monitorDeEmbarque,
  totalCupos,
  totalesCircuito,
  totalStock,
  totalMercaderia
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(Dashboard)
